
import React from "react";
import currency from "currency.js";
import { Paper } from "material-ui";
import { withStyles } from "material-ui/styles";
import Form from "../../../controls/Form";
import NumberTextField from "../../../controls/textfields/NumberTextField";

const styles = () => ({
  page: {
    width: "100%",
    maxWidth: "760px",
    margin: "0 auto",
    boxSizing: "border-box"
  },
  card: {
    borderRadius: "18px",
    overflow: "hidden",
    background: "#ffffff",
    border: "1px solid #e4eeea",
    boxShadow: "0 12px 35px rgba(24, 61, 50, 0.08)"
  },
  header: {
    padding: "20px 22px",
    background: "#173f34",
    color: "#ffffff"
  },
  headerLabel: {
    fontSize: "10px",
    fontWeight: 800,
    letterSpacing: "1px",
    textTransform: "uppercase",
    opacity: 0.7,
    marginBottom: "5px"
  },
  headerTitle: {
    fontSize: "22px",
    fontWeight: 800,
    margin: 0
  },
  headerTransaction: {
    marginTop: "6px",
    fontSize: "10px",
    opacity: 0.65
  },
  summary: {
    padding: "18px 22px",
    background: "#f7faf8",
    borderBottom: "1px solid #e6eeeb"
  },
  summaryRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "7px 0"
  },
  summaryLabel: {
    fontSize: "12px",
    color: "#71817b",
    fontWeight: 600
  },
  summaryValue: {
    fontSize: "12px",
    color: "#34483f",
    fontWeight: 700
  },
  totalRow: {
    marginTop: "8px",
    paddingTop: "14px",
    borderTop: "1px solid #dfe9e5",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  totalLabel: {
    fontSize: "12px",
    fontWeight: 800,
    color: "#19352d",
    textTransform: "uppercase",
    letterSpacing: "0.5px"
  },
  totalValue: {
    fontSize: "25px",
    fontWeight: 900,
    color: "#16845b"
  },
  paymentArea: {
    padding: "22px"
  },
  paymentLabel: {
    display: "block",
    fontSize: "11px",
    fontWeight: 800,
    color: "#19352d",
    textTransform: "uppercase",
    letterSpacing: "0.6px",
    marginBottom: "9px"
  },
  paymentMethods: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "10px",
    marginBottom: "20px"
  },
  paymentMethod: {
    border: "1px solid #dfeae5",
    borderRadius: "13px",
    background: "#ffffff",
    padding: "15px 8px",
    cursor: "pointer",
    textAlign: "center",
    transition: "all 0.15s ease"
  },
  paymentMethodActive: {
    border: "2px solid #16845b",
    background: "#edf8f3",
    boxShadow: "0 5px 15px rgba(22, 132, 91, 0.10)"
  },
  paymentMethodIcon: {
    fontSize: "22px",
    marginBottom: "7px"
  },
  paymentMethodName: {
    display: "block",
    fontSize: "11px",
    fontWeight: 800,
    color: "#19352d"
  },
  paymentMethodHint: {
    display: "block",
    marginTop: "3px",
    fontSize: "8px",
    color: "#7a8b84"
  },
  amountBox: {
    padding: "16px",
    borderRadius: "13px",
    background: "#f8fbfa",
    border: "1px solid #dfeae5"
  },
  splitBox: {
    marginTop: "18px",
    padding: "16px",
    borderRadius: "13px",
    background: "#f8fbfa",
    border: "1px solid #dfeae5"
  },
  splitMethods: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "8px",
    marginBottom: "15px"
  },
  splitMethodButton: {
    border: "1px solid #dfeae5",
    borderRadius: "9px",
    background: "#ffffff",
    padding: "10px",
    cursor: "pointer",
    fontSize: "11px",
    fontWeight: 700
  },
  splitMethodActive: {
    border: "2px solid #16845b",
    background: "#edf8f3"
  },
  addPaymentButton: {
    width: "100%",
    marginTop: "12px",
    border: "none",
    borderRadius: "10px",
    padding: "12px",
    background: "#173f34",
    color: "#ffffff",
    fontSize: "12px",
    fontWeight: 800,
    cursor: "pointer"
  },
  paymentsList: {
    marginTop: "18px"
  },
  paymentsTitle: {
    fontSize: "11px",
    fontWeight: 800,
    color: "#19352d",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginBottom: "8px"
  },
  paymentRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 12px",
    marginBottom: "7px",
    borderRadius: "9px",
    background: "#ffffff",
    border: "1px solid #e1ebe7"
  },
  paymentRowLeft: {
    display: "flex",
    flexDirection: "column"
  },
  paymentRowMethod: {
    fontSize: "12px",
    fontWeight: 800,
    color: "#19352d"
  },
  paymentRowAmount: {
    fontSize: "13px",
    fontWeight: 900,
    color: "#16845b"
  },
  removeButton: {
    border: "none",
    background: "#fee2e2",
    color: "#b91c1c",
    borderRadius: "7px",
    padding: "6px 9px",
    cursor: "pointer",
    fontSize: "10px",
    fontWeight: 800
  },
  balanceBox: {
    marginTop: "15px",
    padding: "14px 16px",
    borderRadius: "12px",
    background: "#edf8f3",
    border: "1px solid #cce9db",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  balanceLabel: {
    fontSize: "11px",
    fontWeight: 700,
    color: "#587168"
  },
  balanceValue: {
    fontSize: "17px",
    fontWeight: 900,
    color: "#16845b"
  },
  transactionNote: {
    marginTop: "14px",
    padding: "10px 12px",
    borderRadius: "9px",
    background: "#fff8e8",
    border: "1px solid #f5dfaa",
    color: "#8a6b28",
    fontSize: "10px",
    lineHeight: "15px"
  }
});

const NormalSaleForm = props => {
  const {
    errors,
    data,
    transactionId,
    cart,
    classes,
    onChange,
    onPaymentMethodChange,
    onSplitPaymentMethodChange,
    onAddSplitPayment,
    onRemoveSplitPayment,
    onSubmit,
    onCancel
  } = props;

  const { summary } = cart;

  const totalDiscount = currency(summary.discountOnItems)
    .add(summary.discountOnTotal)
    .toString();

  const paymentMethods = [
    {
      value: "CASH",
      icon: "\u20A6",
      name: "Cash",
      hint: "Cash payment"
    },
    {
      value: "TRANSFER",
      icon: "\u21C4",
      name: "Transfer",
      hint: "Bank transfer"
    },
    {
      value: "CARD",
      icon: "\u25A3",
      name: "Card",
      hint: "Card payment"
    },
    {
      value: "SPLIT",
      icon: "\u00F7",
      name: "Split",
      hint: "Multiple methods"
    }
  ];

  const splitMethods = [
    {
      value: "CASH",
      name: "Cash"
    },
    {
      value: "TRANSFER",
      name: "Transfer"
    },
    {
      value: "CARD",
      name: "Card"
    }
  ];

  const totalPaid = data.payments
    ? data.payments.reduce(
        (total, payment) =>
          currency(total).add(payment.amount).value,
        0
      )
    : 0;

  const remaining = currency(summary.netTotal)
    .subtract(totalPaid)
    .value;

  return (
    <div className={classes.page}>
      <Paper className={classes.card} elevation={0}>

        <div className={classes.header}>
          <div className={classes.headerLabel}>Checkout</div>

          <h2 className={classes.headerTitle}>
            Complete Sale
          </h2>

          <div className={classes.headerTransaction}>
            Transaction #{transactionId}
          </div>
        </div>

        <div className={classes.summary}>
          <div className={classes.summaryRow}>
            <span className={classes.summaryLabel}>
              Subtotal
            </span>

            <span className={classes.summaryValue}>
              {"\u20A6"}{Number(summary.total || 0).toLocaleString()}
            </span>
          </div>

          <div className={classes.summaryRow}>
            <span className={classes.summaryLabel}>
              Discount
            </span>

            <span className={classes.summaryValue}>
              {"\u20A6"}{Number(totalDiscount || 0).toLocaleString()}
            </span>
          </div>

          <div className={classes.summaryRow}>
            <span className={classes.summaryLabel}>
              Tax
            </span>

            <span className={classes.summaryValue}>
              {"\u20A6"}{Number(summary.taxAmount || 0).toLocaleString()}
            </span>
          </div>

          <div className={classes.totalRow}>
            <span className={classes.totalLabel}>
              Total to Pay
            </span>

            <span className={classes.totalValue}>
              {"\u20A6"}{Number(summary.netTotal || 0).toLocaleString()}
            </span>
          </div>
        </div>

        <div className={classes.paymentArea}>
          <div>

            <label className={classes.paymentLabel}>
              Payment Method
            </label>

            <div className={classes.paymentMethods}>
              {paymentMethods.map(method => {
                const active =
                  data.paymentMethod === method.value;

                return (
                  <button
                    key={method.value}
                    type="button"
                    className={
                      active
                        ? `${classes.paymentMethod} ${classes.paymentMethodActive}`
                        : classes.paymentMethod
                    }
                    onClick={() =>
                      onPaymentMethodChange(method.value)
                    }
                  >
                    <div className={classes.paymentMethodIcon}>
                      {method.icon}
                    </div>

                    <span className={classes.paymentMethodName}>
                      {method.name}
                    </span>

                    <span className={classes.paymentMethodHint}>
                      {method.hint}
                    </span>
                  </button>
                );
              })}
            </div>

            {data.paymentMethod === "SPLIT" ? (
              <div className={classes.splitBox}>

                <label className={classes.paymentLabel}>
                  Add Payment
                </label>

                <div className={classes.splitMethods}>
                  {splitMethods.map(method => {
                    const active =
                      data.splitPaymentMethod === method.value;

                    return (
                      <button
                        key={method.value}
                        type="button"
                        className={
                          active
                            ? `${classes.splitMethodButton} ${classes.splitMethodActive}`
                            : classes.splitMethodButton
                        }
                        onClick={() =>
                          onSplitPaymentMethodChange(
                            method.value
                          )
                        }
                      >
                        {method.name}
                      </button>
                    );
                  })}
                </div>

                <div className={classes.amountBox}>
                  <NumberTextField
                    autoFocus
                    error={!!errors.amountPaid}
                    name="amountPaid"
                    value={data.amountPaid}
                    label="Enter payment amount"
                    onChange={onChange}
                    helperText={errors.amountPaid}
                  />

                  <button
                    type="button"
                    className={classes.addPaymentButton}
                    onClick={onAddSplitPayment}
                  >
                    + Add Payment
                  </button>
                </div>

                {data.payments && data.payments.length > 0 ? (
                  <div className={classes.paymentsList}>

                    <div className={classes.paymentsTitle}>
                      Payments Added
                    </div>

                    {data.payments.map((payment, index) => (
                      <div
                        key={`${payment.paymentMethod}-${index}`}
                        className={classes.paymentRow}
                      >
                        <div className={classes.paymentRowLeft}>
                          <span className={classes.paymentRowMethod}>
                            {payment.paymentMethod}
                          </span>

                          <span className={classes.paymentRowAmount}>
                            {"\u20A6"}{Number(
                              payment.amount || 0
                            ).toLocaleString()}
                          </span>
                        </div>

                        <button
                          type="button"
                          className={classes.removeButton}
                          onClick={() =>
                            onRemoveSplitPayment(index)
                          }
                        >
                          Remove
                        </button>
                      </div>
                    ))}

                  </div>
                ) : null}

                <div className={classes.balanceBox}>
                  <span className={classes.balanceLabel}>
                    Remaining
                  </span>

                  <span className={classes.balanceValue}>
                    {"\u20A6"}{Number(
                      remaining > 0 ? remaining : 0
                    ).toLocaleString()}
                  </span>
                </div>

              </div>
            ) : (
              <React.Fragment>

                <label className={classes.paymentLabel}>
                  Amount Received
                </label>

                <div className={classes.amountBox}>
                  <NumberTextField
                    autoFocus
                    error={!!errors.amountPaid}
                    name="amountPaid"
                    value={data.amountPaid}
                    label="Enter amount received"
                    onChange={onChange}
                    helperText={errors.amountPaid}
                  />
                </div>

                <div className={classes.balanceBox}>
                  <span className={classes.balanceLabel}>
                    Change
                  </span>

                  <span className={classes.balanceValue}>
                    {"\u20A6"}{Number(
                      data.balanceToPay || 0
                    ).toLocaleString()}
                  </span>
                </div>

              </React.Fragment>
            )}

            <div className={classes.transactionNote}>
              Transaction #{transactionId} is being processed through
              the existing POS checkout system.
            </div>

            <div style={{ marginTop: "18px" }}>
              <Form
                style={{ margin: 0, padding: 0 }}
                id="customer"
                onSubmit={onSubmit}
                onCancel={onCancel}
              />
            </div>

          </div>
        </div>
      </Paper>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(NormalSaleForm);





